import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Fields, reduxForm, reset } from 'redux-form';
import 'react-datepicker/dist/react-datepicker.css';
import { FormattedMessage, injectIntl } from 'react-intl';
import {
  Button,
  Modal } from 'react-bootstrap';
import { connect } from 'react-redux';

import {
  generateValidation,
} from 'ecs-react-components/dist/index.es';
import { findCcdaExternalSystems } from '../../../redux/modules/health-summary/external-systems-mapper';
import {
  filterHealthSummary,
} from '../../../redux/modules/health-summary/health-summary-middleware';
import {
  optionsSelected,
  updateHealthSummaryIdentifier,
} from '../../../redux/modules/health-summary/actions/creators';
import { externalSystemSelected } from '../../../redux/modules/external-systems/actions/creators';

import { messages } from './CcdaOptionsForm.i18n';
import validations from './CcdaOptionsForm.validations';
import { messages as pageMessages } from '../HealthSummary.i18n';

import { findVisitIndex } from '../../../redux/modules/health-summary/health-summary-mapper';
import DateRange from './DateRange';
import Dropdown from './Dropdown';
import RecentVisits from './RecentVisits';

export const fields = ['startDate', 'endDate', 'externalSystemsField', 'recentVisitIndexField', 'radioValueField'];

class CcdaOptionsForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fromDateInvalid: false,
      toDateInvalid: false,
      externalSystemInvalid: false,
      recentVisitIndexInvalid: false,
      showOptionsModal: false,
    };
  }

  onSubmit = (formValues) => {
    const {
      dispatch,
      recentVisits,
    } = this.props;

    const {
      externalSystemsField,
      recentVisitIndexField,
      radioValueField,
    } = formValues;

    const startDate = moment(formValues.startDate);
    const endDate = moment(formValues.endDate);

    if (radioValueField === 'visits') {
      if (recentVisitIndexField < 0 || recentVisitIndexField >= recentVisits.length) {
        this.setState({
          recentVisitIndexInvalid: true,
        });
        return;
      }

      dispatch(optionsSelected({
        radioValue: radioValueField,
        selectedVisitIdentifier: recentVisits[recentVisitIndexField].identifier,
      }));

      if (recentVisits && recentVisits.length) {
        dispatch(updateHealthSummaryIdentifier(
          recentVisits[recentVisitIndexField].identifier
        ));
      }

      this.closeOptionsModal();
      return;
    }
    if (radioValueField === 'daterange') {
      if (!(startDate && startDate.isValid())) {
        this.setState({
          fromDateInvalid: true,
        });
        return;
      }

      if (!(endDate && endDate.isValid())) {
        this.setState({
          toDateInvalid: true,
        });
        return;
      }
    }

    if (!(externalSystemsField)) {
      this.setState({
        externalSystemInvalid: true,
      });
      return;
    }

    let earlyDate = startDate;
    let lateDate = endDate;

    if (startDate.isAfter(endDate)) {
      earlyDate = endDate;
      lateDate = startDate;
    }

    dispatch(optionsSelected({
      startDate: earlyDate.format('l'),
      endDate: lateDate.format('l'),
      radioValue: radioValueField,
      selectedExternalSystem: externalSystemsField,
    }));

    this.filterHealthSummaries(formValues);

    if (externalSystemsField) {
      dispatch(externalSystemSelected(true));
    }

    this.closeOptionsModal();
  }

  closeOptionsModal = () => {
    this.props.dispatch(reset('ccdaOptionsForm'));
    this.setState({ showOptionsModal: false });
  }

  canTriggerButton = (event) => (
    event &&
    (event.type === 'click' ||
    (event.type === 'keypress' &&
      (event.charCode === 13 || event.keyCode === 13)))
  );

  openOptionsModal = (event) => {
    if (this.canTriggerButton(event)) {
      this.setState({ showOptionsModal: true });
    }
  }

  handleRadioChange = (e) => {
    this.props.change('radioValueField', e.currentTarget.value);

    // Clear the recentVisitIndex selection
    if (e.currentTarget.value !== 'visits') {
      this.props.change('recentVisitIndexField', -1);
    }

    this.setState({
      fromDateInvalid: false,
      toDateInvalid: false,
      externalSystemInvalid: false,
      recentVisitIndexInvalid: false,
    });
  };

  filterHealthSummaries = (formValues) => {
    const {
      patientId,
      dispatch,
    } = this.props;

    const {
      externalSystemsField,
    } = formValues;

    const startDate = moment(formValues.startDate);
    const endDate = moment(formValues.endDate);

    const dateFormat = 'YYYY-MM-DD';
    let earlyDate = startDate;
    let lateDate = endDate;
    if (startDate.isAfter(endDate)) {
      earlyDate = endDate;
      lateDate = startDate;
    }

    dispatch(filterHealthSummary(patientId, {
      ifSystemId: externalSystemsField,
      startDate: earlyDate.format(dateFormat),
      endDate: lateDate.format(dateFormat),
    }));
  }

  renderFields = (fieldsMeta) => {
    const {
      externalSystemsField,
      recentVisitIndexField,
      radioValueField,
      recentVisits,
      fromDateInvalid,
      toDateInvalid,
      recentVisitIndexInvalid,
      externalSystemInvalid,
    } = fieldsMeta;

    return (
      <div>
        <div className="form-group">
        <div className="form-check">
          <label htmlFor="optionGroupDates" className="form-check-label bold">
            <input
              type="radio"
              name="optionGroup"
              id="optionGroupDates"
              value="daterange"
              onChange={ this.handleRadioChange }
              checked={radioValueField.input.value === 'daterange'}
              className="form-check-input"
            />
            <FormattedMessage {...messages.page.form.label.daterange} />&nbsp;
            { (fromDateInvalid || toDateInvalid) &&
              <span className="form-validation-error" aria-describedby="dates_required" >
                <span id="dates_required">
                  <FormattedMessage {...messages.page.form.error.dateRequired} />
                </span>
              </span>}
          </label>
        </div>
        <DateRange
          fieldsMeta={fieldsMeta}
          change={this.props.change}
          initFromDateInvalid={ () => { this.setState({ fromDateInvalid: false }) } }
          initToDateInvalid={ () => { this.setState({ toDateInvalid: false }) } }
        />
        <Dropdown
          field={externalSystemsField.input}
          externalSystemInvalid={externalSystemInvalid}
          change={this.props.change}
          initExternalSystemInvalid={() => { this.setState({ externalSystemInvalid: false }); }}
        />
        </div>
        <hr />
        <div className="form-group">
        <div className="form-check">
          <label htmlFor="optionGroupVisits" className="form-check-label bold">
            <input
              type="radio"
              name="optionGroup"
              id="optionGroupVisits"
              value="visits"
              onChange={ this.handleRadioChange }
              disabled={!(recentVisits && recentVisits.length)}
              checked={radioValueField.input.value === 'visits'}
              className="form-check-input"
            />
            <FormattedMessage {...messages.page.form.label.visits} />&nbsp;
            { (recentVisitIndexInvalid) &&
              <span className="form-validation-error" role="alert">
                <FormattedMessage {...messages.page.form.error.visitPickRequired} />
              </span>}
          </label>
        </div>
        </div>
        <RecentVisits
          recentVisits={recentVisits}
          recentVisitIndexField={recentVisitIndexField.input}
          change={this.props.change}
          initRecentVisitIndexInvalid={() => { this.setState({ recentVisitIndexInvalid: false }); }}
        />
      </div>
    );
  }

  render = () => {
    const { handleSubmit,
      recentVisits,
    } = this.props;

    const {
      fromDateInvalid,
      toDateInvalid,
      externalSystemInvalid,
      recentVisitIndexInvalid,
    } = this.state;

    return (
      <>
        <a type="button" className="btn btn-link mb-1 theme" data-toggle="modal" tabIndex="0"
          data-qa-item="OptionsButton" data-target="#health-summary-options"
          onClick={ this.openOptionsModal }
          onKeyPress={ this.openOptionsModal }
          aria-describedby="opensPopupLabel"
          role="link"
        >
          <span className="fa-solid fa-gear mr-1"></span>
          <FormattedMessage {...pageMessages.page.options} />
        </a>
        <Modal show={ this.state.showOptionsModal }
          onHide={ this.closeOptionsModal }
          backdrop="static"
          aria-labelledby="modalTitle"
        >
          <Modal.Header closeButton>
            <Modal.Title data-qa-item="modal-title" as="h4" className="fs-5">
              <div id="modalTitle" tabIndex="0">
                <FormattedMessage {...messages.page.title} />
              </div>
            </Modal.Title>
          </Modal.Header>
          <form onSubmit={handleSubmit(this.onSubmit)}>
            <Modal.Body>
              <p data-qa-item="PrimaryExplanation" tabIndex="0">
                <FormattedMessage {...messages.page.instruction} />
              </p>
              <Fields names={fields}
                component={this.renderFields}
                recentVisits={recentVisits}
                fromDateInvalid={fromDateInvalid}
                toDateInvalid={toDateInvalid}
                externalSystemInvalid={externalSystemInvalid}
                recentVisitIndexInvalid={recentVisitIndexInvalid}
              />
            </Modal.Body>
            <Modal.Footer>
              <Button
                type="submit"
                data-qa-item="SubmitButton"
              >
                <FormattedMessage {...messages.page.form.button.update} />
              </Button>
              <Button type="button"
                variant="outline-secondary"
                onClick={ this.closeOptionsModal }
                data-qa-item="CancelButton"
              >
                <FormattedMessage {...messages.page.form.button.cancel} />
              </Button>
            </Modal.Footer>
          </form>
        </Modal>
      </>
    );
  }
}

CcdaOptionsForm.propTypes = {
  language: PropTypes.string,
  fields: PropTypes.array,
  form: PropTypes.string,
  dispatch: PropTypes.func,
  healthSummaryOptions: PropTypes.object,
  patientId: PropTypes.string,
  handleSubmit: PropTypes.func,
  recentVisits: PropTypes.array,
  intl: PropTypes.object,
  change: PropTypes.func,
};

const formConfig = {
  form: 'ccdaOptionsForm',
  fields,
  enableReinitialize: true,
  ...generateValidation(validations),
};

const mapStateToProps = (state) => {
  const ccdaExternalSystems = findCcdaExternalSystems(state.externalSystems.externalSystems);
  const externalSystemId = ccdaExternalSystems && ccdaExternalSystems.length === 1 ?
    ccdaExternalSystems[0].ifSystemId :
    state.healthSummary.options.selectedExternalSystem;

  return {
    healthSummaryOptions: state.healthSummary.options,
    recentVisits: state.healthSummary.recentVisits,
    patientId: state.profile.patient.patientId,
    initialValues: {
      startDate: moment(state.healthSummary.options.startDate).toDate(),
      endDate: moment(state.healthSummary.options.endDate).toDate(),
      radioValueField: state.healthSummary.options.radioValue,
      externalSystemsField: externalSystemId || null,
      recentVisitIndexField: findVisitIndex(state.healthSummary.recentVisits,
        state.healthSummary.options.selectedVisitIdentifier),
    },
    language: state.language.languageCode,
  };
};

export default (connect(mapStateToProps)(reduxForm(formConfig)(injectIntl(CcdaOptionsForm))));
